module.exports = __webpack_public_path__ + "img/arrowRight.b8c6c851.svg";